module.exports = __webpack_public_path__ + "static/media/06.a8e6284d.mp3";